import Chicken from "./categories/Chicken";
import Beef from "./categories/Beef";
import Seafood from "./categories/Seafood";
import SideOrder from "./categories/SideOrder";
import ChefsSpecialties from "./categories/ChefsSpecialties";
import CombinationPlatters from "./categories/CombinationPlatters";
import SpecialLuncheon from "./categories/SpecialLuncheon";
import Beverages from "./categories/Beverages";
import MeiFun from "./categories/MeiFun";
import LoMein from "./categories/LoMein";
import Appetizers from "./categories/Appetizers";
import ChildrensMenu from "./categories/ChildrensMenu";
import Soups from "./categories/Soups";
import HealthyFoodSelections from "./categories/HealthyFoodSelections";
import Vegetable from "./categories/Vegetable";
import Pork from "./categories/Pork";
import ChickenWingsSpecial from "./categories/ChickenWingsSpecial";
import FriedRice from "./categories/FriedRice";
import EggFooYoung from "./categories/EggFooYoung";

export const menuCategories = [
    Appetizers,
    ChildrensMenu,
    Soups,
    HealthyFoodSelections,
    Vegetable,
    Pork,
    ChickenWingsSpecial,
    Chicken,
    Beef,
    Seafood,
    FriedRice,
    //EggFooYoung,
    LoMein,
    MeiFun,
    SideOrder,
    ChefsSpecialties,
    CombinationPlatters,
    SpecialLuncheon,
    Beverages
];
